/** Metadados do fluxo de evolução (impressos, retorno, etc.) — persistidos em `clinic_evolutions.metadata`. */

export type EvolutionPrintableCategory =
  | 'prescription'
  | 'certificate'
  | 'exam_order'
  | 'indication'
  | 'report'
  | 'surgical_risk';

export interface EvolutionAttachedPrintable {
  clientKey: string;
  category: EvolutionPrintableCategory;
  templateId?: string;
  templateName: string;
  bodyText: string;
  /** Documento oficial salvo no cadastro (impressão via API igual às páginas Receituários/Atestados). */
  linkedDocumentId?: string;
  linkedDocumentType?: 'prescription' | 'certificate';
}

export interface EvolutionReturnWorkflow {
  returnWithExams: boolean;
  returnForSurgery: boolean;
  /** dias até retorno */
  returnInDays: string;
  /** dias para reavaliação */
  reevaluationInDays: string;
  dischargeNoRecall: boolean;
}

export const defaultEvolutionReturnWorkflow = (): EvolutionReturnWorkflow => ({
  returnWithExams: false,
  returnForSurgery: false,
  returnInDays: '',
  reevaluationInDays: '',
  dischargeNoRecall: false,
});
